import React, { createContext, useContext, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("admin_token") || "");
  const [username, setUsername] = useState(() => localStorage.getItem("admin_user") || "");

  const login = async (u, p) => {
    const res = await axios.post(`${API}/auth/login`, { username: u, password: p });
    setToken(res.data.token);
    setUsername(res.data.username);
    localStorage.setItem("admin_token", res.data.token);
    localStorage.setItem("admin_user", res.data.username);
    return res.data;
  };

  const logout = () => {
    setToken("");
    setUsername("");
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_user");
  };

  const authAxios = axios.create({ baseURL: API });
  authAxios.interceptors.request.use((config) => {
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  return (
    <AuthContext.Provider value={{ token, username, isAuthed: !!token, login, logout, authAxios, API }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AuthContext);
}
